(function () {
  function setActiveButton(buttons, activeButton, attr) {
    buttons.forEach(function (button) {
      var isActive = button === activeButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute(attr, isActive ? 'true' : 'false');
    });
  }

  var input = document.querySelector('[data-distillery-search]');
  var grid = document.querySelector('[data-distillery-grid]');
  var regionButtons = document.querySelectorAll('[data-region-filter]');
  var sortSelect = document.querySelector('[data-distillery-sort]');
  var azNav = document.querySelector('[data-az-nav]');
  var azButtons = document.querySelectorAll('[data-az-letter]');
  var clearFiltersButton = document.querySelector('[data-distillery-clear-filters]');

  if (grid) {
    var cards = grid.querySelectorAll('[data-distillery-name]');
    var noResults = document.querySelector('[data-distillery-no-results]');
    var noResultsMessage = noResults ? noResults.querySelector('p') : null;
    var status = document.querySelector('[data-distillery-search-status]');
    var resultCount = document.querySelector('[data-distillery-count]');
    var originalOrder = Array.prototype.slice.call(grid.children);
    var activeRegion = 'all';

    // Region name -> collection URL, parsed from data-region-urls ("Name::url||Name::url").
    var regionUrls = {};
    (grid.getAttribute('data-region-urls') || '').split('||').forEach(function (pair) {
      if (!pair) return;
      var parts = pair.split('::');
      if (parts.length === 2) regionUrls[parts[0]] = parts[1];
    });

    // Region name -> tile photo URL, parsed from data-region-images the same way.
    var regionImages = {};
    (grid.getAttribute('data-region-images') || '').split('||').forEach(function (pair) {
      if (!pair) return;
      var parts = pair.split('::');
      if (parts.length === 2) regionImages[parts[0]] = parts[1];
    });

    // Region name -> distillery count, parsed from data-region-counts the same way.
    var regionCounts = {};
    (grid.getAttribute('data-region-counts') || '').split('||').forEach(function (pair) {
      if (!pair) return;
      var parts = pair.split('::');
      if (parts.length === 2) regionCounts[parts[0]] = parts[1];
    });

    var escapeHtml = function (value) {
      var div = document.createElement('div');
      div.textContent = value;
      return div.innerHTML;
    };

    var FILLER_CLASS = 'distillery-brand-card__item--filler';

    var buildFillerTile = function (regionKey, span) {
      if (!regionUrls[regionKey]) return null;

      var regionName = escapeHtml(regionKey);
      var regionCount = regionCounts[regionKey];
      var subtextHtml = regionCount
        ? '<p class="distillery-brand-card__filler-subtext">' + regionCount +
          (regionCount === '1' ? ' distillery' : ' distilleries') +
          ' <span aria-hidden="true">→</span></p>'
        : '';

      // No photo/overlay (see the matching CSS comment in section-distilleries-by-brand.css for
      // why) — regionImages is no longer used here as a result, kept populated server-side in
      // case a future treatment wants it back.
      var filler = document.createElement('li');
      filler.className = FILLER_CLASS;
      filler.style.gridColumn = 'span ' + span;
      filler.innerHTML =
        '<a href="' + escapeHtml(regionUrls[regionKey]) + '" class="distillery-brand-card distillery-brand-card--filler">' +
          '<div class="distillery-brand-card__media">' +
            '<span class="distillery-brand-card__filler-eyebrow">Explore more</span>' +
            '<div class="distillery-brand-card__footer">' +
              '<p class="distillery-brand-card__filler-heading">Explore ' + regionName + ' region</p>' +
              subtextHtml +
            '</div>' +
          '</div>' +
        '</a>';
      return filler;
    };

    // Featured tiles span 2 grid columns instead of 1, which can leave a dangling single-column
    // gap when the browser's sparse auto-placement can't fit the next tile in the row's last
    // slot. Rather than let that render as blank space, simulate the same row-major packing
    // here (all tiles share one row-height, so this is a simple width-only bin-packing) and
    // splice in an "Explore X region" filler tile wherever a gap would appear. When a region
    // pill filter is active, a trailing tile for that region is also always appended as the
    // last item, so narrowing down to one region still ends with a way to see the full region.
    var fillGridGaps = function () {
      Array.prototype.slice.call(grid.querySelectorAll('li.' + FILLER_CLASS)).forEach(function (li) {
        li.remove();
      });

      // Featured tiles only render double-width when browsing the full, unfiltered list — see
      // the matching CSS rule for .is-region-filtered in section-distilleries-by-brand.css.
      grid.classList.toggle('is-region-filtered', activeRegion !== 'all');

      var columnCount = getComputedStyle(grid).gridTemplateColumns.split(' ').length;
      if (columnCount <= 1) return;

      var visibleItems = Array.prototype.slice.call(grid.children).filter(function (li) {
        return !li.classList.contains('is-hidden');
      });

      var cursor = 0;
      var previousRegion = null;

      visibleItems.forEach(function (li) {
        var nameEl = li.querySelector('[data-distillery-region]');
        var region = nameEl ? nameEl.getAttribute('data-distillery-region') : null;
        var isFeatured = li.classList.contains('distillery-brand-card__item--featured') && activeRegion === 'all';
        var width = isFeatured ? 2 : 1;

        if (cursor + width > columnCount) {
          // When a region filter is active, every visible card already shares that region, so a
          // mid-list filler here would just repeat the same "Explore X region" tile that's
          // guaranteed to appear at the end below — skip it to avoid showing it twice.
          if (activeRegion === 'all') {
            var remaining = columnCount - cursor;
            var filler = previousRegion && buildFillerTile(previousRegion, remaining);
            if (filler) grid.insertBefore(filler, li);
          }
          cursor = 0;
        }

        cursor = (cursor + width) % columnCount;
        if (region) previousRegion = region;
      });

      if (activeRegion !== 'all') {
        var trailingSpan = cursor > 0 ? columnCount - cursor : 1;
        var trailingFiller = buildFillerTile(activeRegion, trailingSpan);
        if (trailingFiller) grid.appendChild(trailingFiller);
      }
    };

    var applyFilters = function () {
      var query = input ? input.value.trim().toLowerCase() : '';
      var visibleCount = 0;

      cards.forEach(function (card) {
        var name = card.getAttribute('data-distillery-name').toLowerCase();
        var region = card.getAttribute('data-distillery-region');
        var isMatch = name.indexOf(query) !== -1 && (activeRegion === 'all' || region === activeRegion);
        card.closest('li').classList.toggle('is-hidden', !isMatch);
        if (isMatch) visibleCount += 1;
      });

      if (noResults) {
        noResults.hidden = visibleCount !== 0;
      }

      if (resultCount) {
        resultCount.textContent = visibleCount + (visibleCount === 1 ? ' brand' : ' brands');
      }

      if (status) {
        status.textContent = visibleCount === 0 && noResultsMessage
          ? noResultsMessage.textContent
          : visibleCount + (visibleCount === 1 ? ' brand found.' : ' brands found.');
      }

      fillGridGaps();
    };

    if (input) {
      input.addEventListener('input', applyFilters);
    }

    regionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activeRegion = button.getAttribute('data-region-filter');
        setActiveButton(regionButtons, button, 'aria-pressed');
        applyFilters();
      });
    });

    if (clearFiltersButton) {
      clearFiltersButton.addEventListener('click', function () {
        if (input) input.value = '';
        activeRegion = 'all';
        var allButton = document.querySelector('[data-region-filter="all"]');
        if (allButton) setActiveButton(regionButtons, allButton, 'aria-pressed');
        applyFilters();
        if (input) input.focus();
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var sortBy = sortSelect.value;
        var isDefaultSort = sortBy === 'name-asc';

        if (isDefaultSort) {
          originalOrder.forEach(function (li) { grid.appendChild(li); });
        } else {
          var direction = sortBy === 'count-desc' ? -1 : 1;
          var sorted = originalOrder.slice().sort(function (a, b) {
            var countA = Number(a.querySelector('[data-distillery-count]').getAttribute('data-distillery-count'));
            var countB = Number(b.querySelector('[data-distillery-count]').getAttribute('data-distillery-count'));
            return (countA - countB) * direction;
          });
          sorted.forEach(function (li) { grid.appendChild(li); });
        }

        if (azNav) {
          azNav.classList.toggle('is-disabled', !isDefaultSort);
          azButtons.forEach(function (button) { button.disabled = !isDefaultSort; });
        }

        fillGridGaps();
      });
    }

    fillGridGaps();

    var lastColumnCount = getComputedStyle(grid).gridTemplateColumns.split(' ').length;
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var columnCount = getComputedStyle(grid).gridTemplateColumns.split(' ').length;
        if (columnCount !== lastColumnCount) {
          lastColumnCount = columnCount;
          fillGridGaps();
        }
      }, 150);
    });
  }

  azButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var letter = button.getAttribute('data-az-letter');
      var target = document.querySelector('[data-az-anchor="' + letter + '"]');
      if (!target) return;

      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setActiveButton(azButtons, button, 'aria-current');
    });
  });

  var azList = document.querySelector('.distilleries-by-brand__az-list');
  if (azList) {
    var updateAzOverflow = function () {
      azList.classList.toggle('has-overflow', azList.scrollWidth > azList.clientWidth + 1);
    };
    updateAzOverflow();
    window.addEventListener('resize', updateAzOverflow);
  }
})();
